<div class="flex items-center justify-center gap-3">
  <div class="inline-flex rounded-full bg-gray-100 p-1">
    <button
      type="button"
      class="rounded-full px-5 py-2 text-sm font-medium transition-all duration-200"
      [class.bg-indigo-600]="selectedInterval === 'Monthly'"
      [class.text-white]="selectedInterval === 'Monthly'"
      [class.text-gray-600]="selectedInterval !== 'Monthly'"
      [class.shadow-sm]="selectedInterval === 'Monthly'"
      (click)="select('Monthly')"
    >
      Monthly
    </button>
    <button
      type="button"
      class="rounded-full px-5 py-2 text-sm font-medium transition-all duration-200"
      [class.bg-indigo-600]="selectedInterval === 'Yearly'"
      [class.text-white]="selectedInterval === 'Yearly'"
      [class.text-gray-600]="selectedInterval !== 'Yearly'"
      [class.shadow-sm]="selectedInterval === 'Yearly'"
      (click)="select('Yearly')"
    >
      Yearly
    </button>
  </div>
  <span
    *ngIf="savingsPercent > 0 && selectedInterval === 'Yearly'"
    class="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700"
  >
    Save {{ savingsPercent }}%
  </span>
</div>
